import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import theme from "./theme";
import { getStyles } from "./App.styles";
import Hero from "./components/hero";
import Statistics from "./components/statistics";
import Mission from "./components/mission";
import Results from "./components/results";
import Counter from "./components/counter";
import Header from "./components/header/Header";
import Footer from "./components/footer";
import Partners from "./components/partners";
import ChildrenWishes from "./components/childrenWishes";

declare global {
  interface Window {
    gtag?: (command: string, ...args: any[]) => void;
    dataLayer?: Record<string, any>[];
  }
}

const App = () => {
  const styles = getStyles();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Box sx={styles.container}>
        <Box sx={styles.mainContent}>
          <Hero />
          <Statistics />
          <Mission />
          <Counter />
          <ChildrenWishes />
          <Results />
          <Partners />
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default App;
